import { ReactNode, useState } from "react";
import { Button } from "../Button";
import { Modal } from "../Modal";
import { CloseIcon } from "../../assets/svgs/CloseIcon";
import { DateField } from "../InputField/DateField";
import { MDY_DATE_FORMAT_THREE } from "../../utils/filters";
import { format, parseISO } from "date-fns";
import { SelectField } from "../InputField/SelectField";

type GenericModalProps = {
  title: string;
  btnText: string;
  open: boolean;
  loading: boolean;
  children?: ReactNode;
  statusData?: { value: string; label: string }[];
  statusText: string;
  closeHandler: () => void;
  filterFn: (to?: string | Date, from?: string | Date, status?: string) => void;
  downloadFn?: (
    to?: string | Date,
    from?: string | Date,
    status?: string
  ) => void;
};

export function GenericFilter({
  title,
  btnText,
  open,
  loading,
  closeHandler,
  filterFn,
  downloadFn,
  children,
  statusText,
  statusData,
}: GenericModalProps) {
  const [filter, setFilter] = useState<{
    from: string | Date;
    to: string | Date;
    status: string;
  }>({
    from: "",
    to: "",
    status: "",
  });
  const handleFilter = (value: string) => {
    if (value === "filter") {
      filterFn(filter.to || "", filter.from || "", filter.status);
    } else {
      downloadFn?.(filter.to || "", filter.from || "", filter.status);
    }
  };

  // console.log((filter.to || "", filter.from || "", filter.status));

  // console.log(filter);

  return (
    <Modal
      open={open}
      className="transaction-filter-modal"
      closeHanlder={closeHandler}
      headerControls={
        <div className="tw-w-full tw-flex tw-justify-between">
          <h6 className="tw-text-[1.25em] tw-font-[600] tw-text-neutral-800">
            {/* Set custom date */}
            Filter
          </h6>

          <div onClick={closeHandler}>
            <CloseIcon />
          </div>
        </div>
      }
      content={
        <div className="filter-content">
          <form>
            <div className="filter-period">
              <h6 className="tw-text-[1em] tw-font-[500] tw-text-neutral-800">
                {/* Choose a period to filter reports */}
                {title}
              </h6>
              <div className="tw-w-full tw-flex tw-flex-col tw-gap-[1.5em]  tw-z-[100]">
                <DateField
                  label="Start Date"
                  changeFn={(name, value) =>
                    setFilter({
                      ...filter,
                      [name]: format(
                        parseISO(value as string),
                        MDY_DATE_FORMAT_THREE
                      ),
                    })
                  }
                  name="from"
                  value={parseISO(filter.from as string)}
                  className="filter-input"
                />
                <DateField
                  label="End Date"
                  changeFn={(name, value) =>
                    setFilter({
                      ...filter,
                      [name]: format(
                        parseISO(value as string),
                        MDY_DATE_FORMAT_THREE
                      ),
                    })
                  }
                  name="to"
                  value={parseISO(filter.to as string)}
                  className="filter-input"
                />
              </div>
            </div>

            {statusData && (
              <div className="tw-w-full tw-mt-[1em] tw-mb-[5em] tw-flex tw-flex-col tw-gap-[.5em]  ">
                <h6 className="tw-text-[1em] tw-font-[500] tw-text-neutral-800">
                  {statusText}
                </h6>

                <SelectField
                  label="Select Type"
                  placeholder="Select Type"
                  value={filter.status}
                  changeFn={(_name, value) =>
                    setFilter({ ...filter, status: value as string })
                  }
                  options={statusData}
                />
              </div>
            )}

            <div className="tw-w-full tw-flex tw-gap-[1em]">
              <Button
                color="active-blue"
                text={btnText}
                type="button"
                disabled={loading}
                onClick={() => handleFilter("filter")}
                className="!tw-w-full !tw-h-[3em]"
              />
              {downloadFn && (
                <Button
                  outlined
                  text="Download "
                  color="active-blue"
                  type="button"
                  onClick={() => handleFilter("download")}
                  className="!tw-w-full !tw-h-[3em]"
                  style={{ marginTop: 0 }}
                />
              )}
            </div>
          </form>
        </div>
      }
    />
  );
}
